var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",staticStyle:{"text-align":"center"},attrs:{"orderId":_vm.id,"payMethod":this.apply.payMethod,"applyResult":_vm.apply.result}})
}
var staticRenderFns = []

export { render, staticRenderFns }